import { Shield, Server, CreditCard, Mail, Brain } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEOHead } from '../components/SEOHead';
import { useLanguage } from '../lib/i18n/context';

export function DatenschutzPage() {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <>
      <SEOHead 
        title={t('privacy.title') + ' | ABCbrain.xyz'}
        description={t('privacy.subtitle')}
        canonicalPath={language === 'de' ? '/de/datenschutz' : '/en/privacy'}
      />
      
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <Shield className="h-16 w-16 text-primary-500 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {t('privacy.title')}
          </h1>
          <p className="text-lg text-gray-600">
            {t('privacy.subtitle')}
          </p>
        </div>

        <div className="prose prose-gray max-w-none">
          <div className="bg-white rounded-lg p-6 shadow-sm mb-6">
            <p className="text-gray-700 mb-4">
              {t('privacy.intro')}
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm mb-6">
            <div className="flex items-center gap-2 mb-4">
              <Server className="h-6 w-6 text-primary-500 flex-shrink-0" />
              <h2 className="text-xl font-semibold text-gray-900 m-0">
                {t('privacy.data.title')}
              </h2>
            </div>
            <p className="text-gray-600 mb-4">
              {t('privacy.data.subtitle')}
            </p>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-lg">•</span>
                <span>
                  <strong>{t('privacy.data.visit.title')}</strong> {t('privacy.data.visit.text')}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lg">•</span>
                <span>
                  <strong>{t('privacy.data.brainstorm.title')}</strong> {t('privacy.data.brainstorm.text')}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lg">•</span>
                <span>
                  <strong>{t('privacy.data.payment.title')}</strong> {t('privacy.data.payment.text')}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lg">•</span>
                <span>
                  <strong>{t('privacy.data.message.title')}</strong> {t('privacy.data.message.text')}
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm mb-6">
            <div className="flex items-center gap-2 mb-4">
              <Brain className="h-6 w-6 text-primary-500 flex-shrink-0" />
              <h2 className="text-xl font-semibold text-gray-900 m-0">
                {t('privacy.ai.title')}
              </h2>
            </div>
            <p className="text-gray-600">
              {t('privacy.ai.text')}
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm mb-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              {t('privacy.not.title')}
            </h2>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-center gap-2">
                <span className="text-xl">🚫</span>
                {t('privacy.not.sell')}
              </li>
              <li className="flex items-center gap-2">
                <span className="text-xl">🚫</span>
                {t('privacy.not.track')}
              </li>
              <li className="flex items-center gap-2">
                <span className="text-xl">🚫</span>
                {t('privacy.not.spam')}
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm mb-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              {t('privacy.cookies.title')}
            </h2>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-lg">•</span>
                {t('privacy.cookies.text1')}
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lg">•</span>
                {t('privacy.cookies.text2')}
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm mb-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              {t('privacy.rights.title')}
            </h2>
            <p className="text-gray-600">
              {t('privacy.rights.text')}
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              {t('privacy.legal.title')}
            </h2>
            <ul className="space-y-3 text-gray-600 mb-6">
              <li className="flex items-start gap-2">
                <span className="text-lg">•</span>
                {t('privacy.legal.text')}
              </li>
            </ul>
            <div className="flex items-center gap-2 text-gray-600 pt-4 border-t">
              <Mail className="h-5 w-5" />
              <span>{t('privacy.contact.text')}</span>
              <a 
                href="mailto:info@ABCbrain.xyz"
                className="text-primary-600 hover:text-primary-700 transition-colors"
              >
                info@ABCbrain.xyz
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}